import Card from "../components/shared/Card/Card";

const ClientDebtMessage = () => {
    let clientDebtData = localStorage.getItem("client_debt");
    clientDebtData = clientDebtData !== "undefined" ? JSON.parse(clientDebtData) : {};

    return clientDebtData?.message ? (
        <Card className="cardDashboard" styleCard={{ backgroundColor: "var(--alert-warning-color)", padding: "1rem" }}>
            <div dangerouslySetInnerHTML={{ __html: clientDebtData?.message }} />
        </Card>
    ) : (
        <></>
    );
};

export default ClientDebtMessage;
